import React from 'react';

const UserCertificate = ({ name, email, certificatePic, onClose }) => {
  return (
    <div className="modal fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50">
      <div className="modal-content bg-white p-6 rounded-md shadow-md relative max-w-lg w-full">
        {/* Top Right Close Button (X) */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-gray-800 text-2xl font-bold"
        >
          &times;
        </button>

        <h2 className="text-lg font-semibold mb-4">{name} شهادة توثيق  </h2>
        <p className="text-gray-500 mb-2">Email: {email}</p>
        {certificatePic ? (
          <div className="overflow-y-auto max-h-[70vh] border rounded-md">
          <img
            src={certificatePic}
            alt="User Certificate"
            className="certificate-image mb-4"
            style={{ width: '100%', height: 'auto' }}
          />
          </div>
        ) : (
          <p>لا يوجد شهادة توثيق</p>
        )}

        {/* Bottom Close Button */}
        <button
          onClick={onClose}
          className="close-button bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 absolute bottom-4 right-4"
        >
          إغلاق
        </button>
      </div>
    </div>
  );
};

export default UserCertificate;
